import React, { Component } from 'react';
import firebase from '../firebase';
import { rand } from '../helpers';

import Loading from './Loading';
import Logo from './Logo';
import Lyric from './Lyric';
import Meta from './Meta';
import RefreshLyric from './RefreshLyric';

class App extends Component {
  constructor() {
    super();
    this.getRandomLyric = this.getRandomLyric.bind(this);

    // initial state
    this.state = {
      isLoading: true,
      lyric: {},
    };
  }

  componentDidMount() {
    const list = firebase.database().ref('lyrics');
    list.once('value', (snapshot) => {
      this.lyrics = snapshot.val();
      this.lyricKeys = Object.keys(this.lyrics);
      this.getRandomLyric();
      this.setState({
        isLoading: false,
      });
    });
  }

  getRandomLyric() {
    // get a new random ID
    const newId = rand(this.lyricKeys);

    // make sure its not the same lyric
    if (this.state.lyric.id === newId) {
      return this.getRandomLyric();
    }

    // set the new lyric (including ID)
    const newLyric = this.lyrics[newId];
    newLyric.id = newId;

    this.setState({
      lyric: newLyric
    });
  }

  render() {
    const { lyric } = this.state;

    if (this.state.isLoading) {
      return <Loading />;
    }

    return (
      <div className="container">
        <header className="grid-header">
          <Logo />
          <RefreshLyric getRandomLyric={this.getRandomLyric} />
        </header>
        <section className="grid-lyric">
          <Lyric text={lyric.text} />
          <Meta artist={lyric.artist} song={lyric.song} spotifyUri={lyric.spotifyUri} />
        </section>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js